import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
// DeveloperBoardIcon removed; using GitHub and LinkedIn instead
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import WorkIcon from '@mui/icons-material/Work';
import ProfileIcon from '@mui/icons-material/FileDownload';
import avatar from '../assets/images/genesis.jpg';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={avatar} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/genesis-solution" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/jonathan-rann" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://www.guru.com/freelancers/genesis-solutions" target="_blank" rel="noreferrer"><WorkIcon/></a>
            <a href="mailto:jCheshireRann@gmail.com" target="_blank" rel="noreferrer"><MailIcon/></a>
            <a href="tel:336-575-5961" target="_blank" rel="noreferrer"><PhoneIcon/></a>
            {/* <a className="cv-download" href="/Resume%20(2025)%20-%20Dr%20Jonathan%20Rann%20-%20Full%20Stack%20Developer%20and%20Data%20Scientist.pdf" target="_blank" rel="noreferrer"><ProfileIcon/></a> */}
          </div>
          <h1 className="company-name">The Project Genesis</h1>
          <h2 className="ceo-name">Dr. Jonathan Rann — CEO</h2>
          <p className="title">Full Stack Developer & Data Scientist</p>
          <p className="tagline">PhD-qualified developer and CEO delivering production-ready ML systems, data-driven products and scalable web applications through The Project Genesis LLC.</p>

          {/* <div className="featured-site">
            <a className="featured-link" href="https://foxxfamily.theprojectgenesis.net/" target="_blank" rel="noreferrer"><strong>Featured:</strong> FamArchive — newly developed website by The Project Genesis LLC</a>
          </div> */}

          <div className="mobile_social_icons">
            <a href="https://github.com/genesis-solution" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/jonathan-rann" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://www.guru.com/freelancers/genesis-solutions" target="_blank" rel="noreferrer"><WorkIcon/></a>
            <a href="mailto:jCheshireRann@gmail.com" target="_blank" rel="noreferrer"><MailIcon/></a>
            <a href="tel:336-575-5961" target="_blank" rel="noreferrer"><PhoneIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;